<div [ngClass]="isDisabled()? 'disabled': ''">
  <p-checkbox [binary]="true" [disabled]="isDisabled()" [(ngModel)]="selectedValue" (onChange)="onChange($event)" />
</div>